module.exports = __webpack_public_path__ + "static/media/under-construction-hero.14a14c71.png";